import React from "react";

const ShotclassDetails = () => {
  return <div>ShotclassDetails</div>;
};

export default ShotclassDetails;
